import React from 'react';
import { useSearchParams } from 'react-router-dom';
import { Banknote } from 'lucide-react';
import { TabCashup } from './Billing';

// Standalone page for the daily cash-up (was a Billing tab).
export default function CashUp() {
  const [params] = useSearchParams();
  const date = params.get('date');   // dashboard links a missed day here
  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <Banknote size={22} className="text-orange-500" />
        <div>
          <h1 className="text-xl font-bold text-gray-800">Cash-up</h1>
          <p className="text-xs text-gray-400">Balance the day&apos;s takings against the till, card machine and bank</p>
        </div>
      </div>
      <TabCashup key={date || 'today'} initialDate={date || undefined} />
    </div>
  );
}
